import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Typography,
  IconButton,
  TableSortLabel,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import "./TableDashboard.scss";
import { ReactComponent as EndIcon } from "../../assets/CardListIcon/end icon.svg";

const TableDashboard = ({ sensorsData, columns, title, next }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("sensorId");
  const [sortedData, setSortedData] = useState([...sensorsData]);

  const handleSort = (field) => {
    const isAsc = orderBy === field && order === "asc";
    const sorted = [...sortedData].sort((a, b) =>
      isAsc
        ? a[field].localeCompare(b[field])
        : b[field].localeCompare(a[field])
    );
    setSortedData(sorted);
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(field);
  };

  return (
    <TableContainer
      component={Paper}
      sx={{ borderRadius: 3, p: 2, width: "100%" }}
    >
      <Typography
        className="tableTitle"
        variant="h5"
        sx={{ mb: 2, fontWeight: "bold" }}
      >
        {title}
      </Typography>
      <div>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column, index) => (
              <TableCell
                key={index}
                sx={{
                  width: column.width ? `${column.width}px` : "auto",
                  fontWeight: "bold",
                }}
              >
                {column.field === "sensorId" || column.field === "contract" ? (
                  <TableSortLabel
                    active={orderBy === column.field}
                    direction={orderBy === column.field ? order : "asc"}
                    onClick={() => handleSort(column.field)}
                  >
                    {column.label}
                  </TableSortLabel>
                ) : (
                  column.label
                )}
              </TableCell>
            ))}
            <TableCell sx={{ width: "50px" }}></TableCell>{" "}
            {/* For the action column */}
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedData.map((sensor) => (
            <TableRow key={sensor.id} hover>
              {columns.map((column, index) => (
                <TableCell
                  key={index}
                  sx={{ width: column.width ? `${column.width}px` : "auto" }}
                >
                  {column.field === "status" ? (
                    <Chip
                      label={sensor[column.field]}
                      className="chiplable"
                      sx={{
                        backgroundColor: sensor.bgColor, // Custom background color
                        color: sensor.colors, // Custom text color
                        "& .MuiChip-label": {
                          fontWeight: "bold", // Customize label style
                        },
                      }}
                    />
                  ) : (
                    sensor[column.field]
                  )}
                </TableCell>
              ))}
              <TableCell align="right">
                <IconButton>
                  <MoreVertIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      </div>
      <Typography className="tableFooter">
        {next} <EndIcon />
      </Typography>
    </TableContainer>
  );
};

export default TableDashboard;
